import React, { Component } from 'react';
import Auth from 'j-toker';
import { Formik } from 'formik';
import { localize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { EmailPhoneNumberConfirmationForm } from './EmailPhoneNumberConfirmationForm';
import NotificationPreferencesForm from 'components/tenant_app/components/notification_preferences/NotificationPreferencesForm';
import { NOTIFICATION_FORM_STEP, EMAIL_PHONE_NUMBER_FORM_STEP } from './LeadInitialization';
import { isValidEmail } from 'helpers/Validator';
import { getTranslatedString } from 'helpers/i18n';
import * as Yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const LeadInitialPreferencesSchema = Yup.object().shape({
  email: Yup.string()
    .required(getTranslatedString('required'))
    .required(getTranslatedString('required'))
    .test('email', getTranslatedString('invalidEmail'), function (value) {
      return isValidEmail(value);
    }),
  phone_number: Yup.string()
    .required(getTranslatedString('required'))
    .required(getTranslatedString('required'))
    .test('phone_number', getTranslatedString('validationErrors.invalidPhone'), function (value) {
      if (!value) return false;
      if (value.replace(/\s/g, '') === '+00000000000') return true;
      const parseResult = parsePhoneNumberFromString(value);
      return parseResult && parseResult.isValid();
    }),
});
class LeadInitialPreferencesForm extends Component {
  render() {
    const { onSubmit, activeStep, formRef } = this.props;
    return (
      <Formik
        initialValues={{
          notification_preferences: this.props.notificationPreferences,
          notice_by_email: this.props.noticeByEmail,
          digital_legal_documents: this.props.digitalLegalDocuments,
          email: this.props.userPreferences.email || Auth.user.email,
          phone_number: this.props.userPreferences.phone_number,
        }}
        onSubmit={onSubmit}
        ref={formRef}
        validationSchema={LeadInitialPreferencesSchema}
      >
        {({ ...formikBag }) => {
          // TODO: separate out notiifcation prefernces + email phone number into two backend calls
          // make the notifications endpoint go to /leads/notification_preferences
          return (
            <form>
              {activeStep === NOTIFICATION_FORM_STEP && (
                <NotificationPreferencesForm {...formikBag} />
              )}

              {activeStep === EMAIL_PHONE_NUMBER_FORM_STEP && (
                <EmailPhoneNumberConfirmationForm {...formikBag} />
              )}
            </form>
          );
        }}
      </Formik>
    );
  }
}

LeadInitialPreferencesForm = connect((state) => ({
  userPreferences: state.userTypes.userPreferences,
  notificationPreferences: state.userTypes.notificationPreferences,
  noticeByEmail: state.userTypes.noticeByEmail,
  digitalLegalDocuments: state.userTypes.digitalLegalDocuments,
}))(LeadInitialPreferencesForm);

export default localize()(LeadInitialPreferencesForm);
